<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="2" class="py-2">
                <span><b>Feedbacks</b></span>
              </b-col>
            </b-row>
            <b-row class="text-left" align-v="center">
              <b-col cols="12" md="3">
                <span style="font-size: 12px">Please Select From Date:</span
                ><br />
                <b-form-input
                  class="pt-1"
                  v-model="from"
                  type="date"
                  id="date1"
                  @change="dateSetting"
                ></b-form-input>
              </b-col>

              <b-col cols="12" md="3">
                <span style="font-size: 12px">Please Select To Date:</span
                ><br />
                <b-form-input
                  class=""
                  v-model="to"
                  type="date"
                  id="date"
                  @change="dateSetting"
                ></b-form-input>
              </b-col>
              <b-col cols="12" md="2" class="pt-3">
                <b-dropdown
                  variant="outline-primary"
                  size="sm"
                  id="dropdown-1"
                  :text="chartName"
                >
                  <b-dropdown-item
                    v-for="(item, i) in chartTypes"
                    :key="i"
                    @click="updateChart(item)"
                    >{{ item.name }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-col>
              <b-col cols="12" md="4" class="pt-3">
                <b-form @submit.prevent="getSearch">
                  <b-row>
                    <b-col cols="8">
                      <b-form-input
                        list="searchData"
                        v-model="searchKey"
                        placeholder="Search"
                        size="md"
                      ></b-form-input>
                      <!-- <datalist id="searchData">
                        <option v-for="(item,i) in searchData" :key="i">{{item.keyword}}</option>
                      </datalist> -->
                    </b-col>
                    <b-col cols="2" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="getSearch"
                        >Search</b-button
                      >
                    </b-col>
                    <b-col cols="1" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        class="px-2"
                        size="sm"
                        to="/Feedbacks"
                        >All</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="feedbacks"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            @row-clicked="rowClicked"
          >
            <template slot="slno" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.createddate">{{ data.index + 1 }}</span>
              </div>
            </template>
            <template slot="feedback" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.body">{{
                  data.item.body.substring(0, 25) + "..."
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            <!-- <template slot="body" slot-scope="data">
              <div class="text-center">
                <span v-if="data.item.body">{{data.item.body.substring(0,10)+'...'}}</span>
                <span v-else>-</span>
              </div>
            </template>-->
            <template slot="createddate" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.createddate">{{
                  formatDate(data.item.createddate)
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="user" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.user">{{ data.item.user.name }}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="email" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.email">{{ data.item.email }}</span>
                <span v-else>-</span>
              </div>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totlaFeedbacks"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
            />
          </nav>
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      feedbacks: [],
      idset: [],
      from: null,
      to: null,
      chartName: "Filter",
      chartType: null,
      chartTypes: [
        { name: "Last 90 days", value: 90 },
        { name: "Last 60 days", value: 60 },
        { name: "Last 30 days", value: 30 },
        { name: "Last 15 days ", value: 15 },
      ],
      fields: [
        // { key: "slno", label: "Sl. No", sortable: false },

        {
          key: "createddate",
          label: "Submitted  On",
          sortable: true,
          align: "center",
        },
        { key: "type", label: "Feedback Type", sortable: true },
        { key: "feedback", label: "Feedback", sortable: true },
        { key: "user", label: "User", sortable: true, align: "center" },

        { key: "status", label: "Status", sortable: true },
        // { key: "_id", label: "Action", sortable: false }
      ],
      searchData: [],
      searchKey: null,
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      totlaFeedbacks: 0,
    };
  },
  mounted() {
    this.searchKey = this.$route.query.searchKey;
    this.from = this.$route.query.from;
    this.to = this.$route.query.to;
    this.chartType = this.$route.query.chartType;
    for (var i = 0; i < this.chartTypes.length; i++) {
      if (this.chartType == this.chartTypes[i].value) {
        this.chartName = this.chartTypes[i].name;
        return;
      }
    }
    this.mySearch();
  },
  watch: {
    "$route.fullpath": {
      handler: function () {
        this.mySearch();
      },
      deep: true,
    },
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getData();
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },

    dateSetting() {
      this.$router.push({
        path: "/Feedbacks",
        query: {
          searchKey: this.$route.query.searchKey,
          from: this.from,
          to: this.to,
          chartType: this.$route.query.chartType,
        },
      });
    },
    updateChart(item) {
      this.chartName = item.name;
      this.chartType = item.value;
      this.$router.push({
        path: "/Feedbacks",
        query: {
          searchKey: this.$route.query.searchKey,
          from: this.$route.query.from,
          to: this.$route.query.to,
          chartType: this.chartType,
        },
      });
    },

    getSearch() {
      this.$router.push({
        path: "/Feedbacks",
        query: {
          searchKey: this.searchKey,
          from: this.$route.query.from,
          to: this.$route.query.to,
          chartType: this.$route.query.chartType,
        },
      });
    },
    mySearch() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/search/feedback",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          keyword: this.$route.query.searchKey,
          from: this.$route.query.from,
          to: this.$route.query.to,
          filter: this.$route.query.chartType,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.feedbacks = response.data.data;
          this.totlaFeedbacks = response.data.count;
          for (var i = 0; i < this.feedbacks.length; i++) {
            this.idset[i] = this.feedbacks[i]._id;
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },

    rowClicked(item) {
      this.$router.push("/Feedbacks/" + item._id + "/" + this.idset);
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
